// extracted by mini-css-extract-plugin
export default {"root":"AppSelectionPage_root__pdfd-","auditorIcon":"AppSelectionPage_auditorIcon__F9g1m"};